import React, { useEffect, useState, useRef, useCallback } from 'react';
import { isMobile } from 'react-device-detect';
import '../../fonts/fonts.css';
import { COLORS, getValueWithoutUnit } from '../../utils';

const getColor = (color) => {
    const result = COLORS.filter((item) => {
        return item.name === color;
    });
    return result[0]?.hex;
};

const Image = ({ design, name, lastName, color, font }) => {
    const coordStyles = useRef([]);
    const [designLoaded, setDesignLoaded] = useState(false);

    const textAlignment = () => {
        switch (design?.defaultAlignment) {
            case 'left':
                return 'text-left';
            case 'center':
                return 'text-center';
            case 'right':
                return 'text-right';
            default:
                return 'text-center';
        }
    };

    const labelStyles = `absolute w-full p-1 top-3  drop-shadow-md ${textAlignment()} ${
        font !== 'ThankYou' ? 'leading-5' : ''
    } ${font ? `font_${font}` : `font_${design?.defaultTypography}`} ${
        color ? `palette_${getColor(color)}` : `palette_${design?.defaultColor}`
    }`;

    const nStickers = design?.labels.length;

    const addCoords = useCallback(() => {
        design?.labels.forEach((label, i) => {
            const specialTypo = font === 'ThankYou';
            coordStyles.current[label.position] = {
                top: `${label.top || 0}`,
                left: `${label.left || 0}`,
                width: `${label.width || 0}`,
                fontSize: `${label.fontSize || '14px'}`,
            };

            if (specialTypo) {
                const fontSizeWithoutUnit = getValueWithoutUnit(label?.fontSize, 'px');
                coordStyles.current[label.position].lineHeight = `${Number(fontSizeWithoutUnit) + 6}px`;
            }
        });
        setDesignLoaded(!designLoaded);
    }, [design, designLoaded, font]);

    useEffect(() => {
        addCoords();
        // eslint-disable-next-line
    }, [design]);

    return (
        <div
            className={`bg-white relative md:sticky md:top-0 md:self-start md:bg-transparent z-20 shadow-lg overflow-hidden h-[565px] -mt-10 md:mt-10 -ml-[75px] md:overflow-auto md:mx-auto`}>
            {nStickers &&
                design?.labels.map((label, i) => {
                    const extraStyling = {};
                    if (coordStyles.current[i]) {
                        const fontSize = coordStyles.current[i].fontSize.split('px');
                        extraStyling.lh = fontSize[0] < 16 ? 'et-lh-13' : '';
                    }
                    return (
                        <div
                            key={`label-${label.position}-${i}`}
                            className={`${labelStyles} ${extraStyling.lh}`}
                            style={coordStyles.current[i]}>
                            {name} {lastName}
                        </div>
                    );
                })}
            {design?.image ? (
                <img
                    onContextMenu={() => false}
                    width="565"
                    className={`z-0 ${isMobile && 'et-mobile-image'}`}
                    src={design?.image}
                    alt="Previsualiza"
                />
            ) : (
                <>
                    {isMobile && (
                        <div className="w-[570px] relative text-center top-1/2 mt-4 text-gray-500">
                            Selecciona un diseño
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default Image;
